import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Hero Section */}
          <Box sx={{ mb: 8, textAlign: 'center' }}>
            <Typography variant="h1" sx={{ color: 'primary.main', mb: 4 }}>
              Our Story
            </Typography>
            <Typography variant="h5" sx={{ mb: 4, maxWidth: '800px', mx: 'auto' }}>
              Since 1961, Weir Roastin' has been perfecting the art of whole hog BBQ,
              bringing authentic flavors and time-honored traditions to every event we cater.
            </Typography>
          </Box>

          {/* History Section */}
          <Grid container spacing={6} sx={{ mb: 8 }}>
            <Grid item xs={12} md={6}>
              <Paper 
                elevation={3}
                sx={{
                  p: 4,
                  height: '100%',
                  background: 'linear-gradient(rgba(123, 104, 238, 0.05), rgba(123, 104, 238, 0.1))'
                }}
              >
                <Typography variant="h3" sx={{ color: 'primary.main', mb: 3 }}>
                  Family Tradition
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Founded in 1961, our family-owned business has been passing down the secrets
                  of perfect whole hog roasting through generations. What started as a passion
                  for authentic BBQ has grown into a premier catering service.
                </Typography>
                <Typography variant="body1">
                  Our commitment to quality and tradition remains unchanged, as we continue
                  to use the same time-tested methods that made us famous over 60 years ago.
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper 
                elevation={3}
                sx={{
                  p: 4,
                  height: '100%',
                  background: 'linear-gradient(rgba(123, 104, 238, 0.05), rgba(123, 104, 238, 0.1))'
                }}
              >
                <Typography variant="h3" sx={{ color: 'primary.main', mb: 3 }}>
                  Our Process
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Every hog is carefully selected from local farms and prepared using our
                  signature dry rub. We slow-roast for 12-14 hours, maintaining the perfect
                  temperature to ensure tender, flavorful meat.
                </Typography>
                <Typography variant="body1">
                  Our experienced pitmasters tend to each roast with dedication and precision,
                  resulting in consistently exceptional BBQ that your guests will remember.
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* Values Section */}
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography variant="h2" sx={{ color: 'primary.main', mb: 6 }}>
              Our Values
            </Typography>
            <Grid container spacing={4}>
              {[
                {
                  title: 'Quality',
                  description: 'Premium ingredients and expert preparation in every roast'
                },
                {
                  title: 'Tradition',
                  description: 'Time-honored cooking methods passed down through generations'
                },
                {
                  title: 'Service',
                  description: 'Dedicated attention to every detail of your event'
                },
                {
                  title: 'Community',
                  description: 'Proud to be locally owned and operated since 1961'
                }
              ].map((value, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Paper 
                      elevation={3}
                      sx={{
                        p: 3,
                        height: '100%',
                        background: 'linear-gradient(rgba(123, 104, 238, 0.05), rgba(123, 104, 238, 0.1))'
                      }}
                    >
                      <Typography variant="h4" sx={{ color: 'primary.main', mb: 2 }}>
                        {value.title}
                      </Typography>
                      <Typography>
                        {value.description}
                      </Typography>
                    </Paper>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default About;
